import request from "../../utils/request";

//用户登录
export const login = (data)=>{
    return  request({
        method:'POST',
        url:'/user/login',
        data
    })
}

//用户注册
export const register = (data)=>{ 
   return  request({
        method:'POST',
        url:'/user/register',
        data
    })
}

// export const checkUsernameExist = (account)=>{
//     return  request({
//          method:'POST',
//          url:`/user/checkUsernameExist/${account}`,
//      })
//  }

 //发送验证码
 export const sendVerifyCode = (codeType,phoneNumber)=>{
    return  request({
         method:'POST',
         url:`/user/sendVerifyCode/${codeType}/${phoneNumber}`,
     })
 }

 //用户登录
export const getUserProfile = (data)=>{
    return  request({
        method:'GET',
        url:'/user/getUserProfile',
        data
    })
}

 //更新用户基本资料
 export const updateWebUserBaseProfile = (data)=>{
    return  request({
        method:'POST',
        url:'/user/updateWebUserBaseProfile',
        data
    })
}

 //用户退出登录
 export const userLogout = (data)=>{
    return  request({
        method:'post',
        url:'/user/userLogout',
        data
    })
}
 
//查询客服QQ、微信是否存在
export const queryCustomerServiceInfo = (data)=>{
return  request({
    method:'POST',
    url:'/user/queryCustomerServiceInfo',
    data
})
}

//重置账户密码时发送短信
export const resetAccountPasswordSendSms = (data)=>{
    return  request({
        method:'GET',
        url:`/user/resetAccountPasswordSendSms/${data}`,
    })
}

//重置账户密码
export const resetAccountPassword = (data)=>{
    return  request({
        method:'POST',
        url:'/user/resetAccountPassword',
        data
    })
}

//获取实名认证信息
export const getRealNameAuthInfo = ()=>{
    return  request({
        method:'GET',
        url:'/user/getRealNameAuthInfo'
    })
}

//提交证件
export const submitIdentityCard = (data)=>{
    return  request({
        method:'POST',
        url:'/user/submitIdentityCard',
        headers:{'Content-Type': 'multipart/form-data'},
        data
    })
}

//提交请求 实人认证前的操作
export const preRealPersonAuthentication = (data)=>{
    return  request({
        method:'POST',
        url:'/user/preRealPersonAuthentication',
        data
    })
}

//刷新实人认证二维码操作
export const refreshRealPersonAuthenticationQRCode = ()=>{
    return  request({
        method:'GET',
        url:'/user/refreshRealPersonAuthenticationQRCode'
    })
}

//实人认证查询认证状态
export const getKycStatusForRealPersonAuthentication = ()=>{
    return  request({
        method:'GET',
        url:'/user/getKycStatusForRealPersonAuthentication'
    })
}

//设置提现信息
export const setWithdrawInfo = (data)=>{
    return  request({
        method:'POST',
        url:'/user/setWithdrawInfo',
        data
    })
}

//设置提现信息
export const getWithdrawInfo = ()=>{
    return  request({
        method:'GET',
        url:'/user/getWithdrawInfo'
    })
}